import React, { useEffect, useState } from 'react';
import { google, outlook, office365, ics } from 'calendar-link';
import { Grid, styled, Typography, Link } from '@mui/material';
import googleImage from '../../assets/Google_Calendar.png';
import outlookImage from '../../assets/Microsoft_Office_Outlook.png';
import office365Image from '../../assets/Microsoft_Office.png';
import downloadImage from '../../assets/folder_download.png';

const CalendarImg = styled('img')(() => ({
    width: '60px',
    padding: '4px',
}));

const ItemGrid = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const SaveCalendar = props => {
    const [calLinks, setCalLinks] = useState({});

    // Create calendar links
    useEffect(() => {
        const offset = -new Date().getTimezoneOffset();
        const hours = Math.floor(offset / 60);
        const minutes = offset % 60;
        const startTime =
            props.booking.startDate +
            '+' +
            ('00' + hours.toString()).slice(-2) +
            ':' +
            ('00' + minutes.toString()).slice(-2);
        const endTime =
            props.booking.endDate +
            '+' +
            ('00' + hours.toString()).slice(-2) +
            ':' +
            ('00' + minutes.toString()).slice(-2);
        const baseUrl = process.env.REACT_APP_hostUrl.replace('/home', '');
        const bookingLink =
            `${baseUrl}/teacher-availability/` +
            `teacher-booking/` +
            `${props.booking.uniqueId}`;
        const event = {
            title: `${props.booking.schoolName} (booked using airTeachr)`,
            location: props.booking.schoolLocation,
            start: startTime,
            end: endTime,
            description: `Click here for booking details: ${bookingLink}`,
        };
        setCalLinks({
            google: google({
                ...event,
                description:
                    `Click <a href="${bookingLink}">here</a>` +
                    ` for booking details`,
            }),
            outlook: outlook(event),
            office365: office365(event),
            ics: ics(event),
        });
    }, []);

    return (
        <Grid container>
            <ItemGrid item xs={12}>
                <Typography variant="h5">Add to Calendar</Typography>
            </ItemGrid>
            <ItemGrid item xs={12}>
                <Link href={calLinks.google}>
                    <CalendarImg src={googleImage} />
                </Link>
                <Link href={calLinks.outlook}>
                    <CalendarImg src={outlookImage} />
                </Link>
                <Link href={calLinks.office365}>
                    <CalendarImg src={office365Image} />
                </Link>
                <Link href={calLinks.ics}>
                    <CalendarImg src={downloadImage} />
                </Link>
            </ItemGrid>
        </Grid>
    );
};

export default SaveCalendar;
